import Metatags from '@components/common/Metatags';
import FeaturedProducts from '@moncler/components/listing/FeaturedProductsCarousel';
import HeroBannerSlim from '@moncler/components/listing/HeroBannerSlim';
import ListingResults from '@moncler/components/listing/ListingResults';
import ProductFilters from '@moncler/components/listing/ProductFilters';
import ListingPagination from '@moncler/components/listing/ListingPagination';
import { useAnimatedContext } from '@moncler/components/routerTransitions/AnimatedProvider';
import { ListingActionTypes } from '@state/features/common.types';
import analytics from '@utils/analytics';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import customEventBus from '@common/scripts/libs/eventBus';
const PlpPage = (props) => {
    const { search: { results, category, pageMetaTags, resultsType, landingAnimation, firstLoad, heroBannerSlim, featuredProductsCarousel, plpintro }, product: { current: productReferrer }, redirect: { error, redirectOnError }, } = useSelector((state) => state);
    useTranslation(); // force immediate loading of translations
    const dispatch = useDispatch();
    const listingContainer = useRef();
    useEffect(() => {
        if (error && redirectOnError) {
            window.location.href = redirectOnError;
        }
    }, [redirectOnError]);
    useEffect(() => {
        // al back da PDP
        if (productReferrer) {
            let subCategory = category ? category.id : productReferrer.categoryId;
            window.datalayerdata = Object.assign(Object.assign({}, window.datalayerdata), { pageCategory: 'plp', subCategory: subCategory, pageDesign: 'special' });
            analytics.sendGeneralVariables();
            analytics.productDetailPageBack(results, false);
            document.documentElement.classList.remove('no-overflow-ios');
            customEventBus.emit('PLP:loaded', {});
        }
    }, []);
    const { subscribe, unsubscribe } = useAnimatedContext();
    const sleep = async (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };
    const setupFunction = async () => {
        // document.querySelector('header')?.style.removeProperty('transform');
        // const refine = document.querySelector('.refine') as HTMLElement;
        // if (refine && window.scrollY > 0) {
        //   refine.style.opacity = '0';
        // }
        await sleep(150);
    };
    const getScrollThreshold = (header, refineContainer) => {
        var _a, _b;
        let isMobile = window.innerWidth < window.mqObj['md'];
        return ((header && header.offsetHeight) +
            (isMobile
                ? (((_a = document.querySelector('.breadcrumb.listing')) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0) +
                    (((_b = document.querySelector('.intro-plp__text-tags-wrapper')) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0) +
                    parseInt(window.getComputedStyle(refineContainer).paddingTop) -
                    parseInt(window.getComputedStyle(refineContainer).paddingBottom) -
                    1
                : refineContainer.offsetHeight));
    };
    useEffect(() => {
        subscribe('setup', setupFunction);
        return () => {
            unsubscribe('setup', setupFunction);
        };
    }, []);
    // initial product fetch
    useEffect(() => {
        if (!resultsType) {
            dispatch({
                type: ListingActionTypes.FETCH_LISTING,
                payload: {
                    cgid: props.cgid,
                    slug: location.pathname,
                    resultsType: 'INIT',
                    start: props.start,
                    isShelf: false,
                },
            });
        }
    }, []);
    // sticky behavior
    useEffect(() => {
        let lastScrollTop = 0;
        let cachedScrollTop = 0;
        const offsetScroll = 32;
        let scrollThreshold = 0;
        let header = document.querySelector('header');
        let firstRefine;
        let firstTime = true;
        const onScroll = () => {
            if (firstTime) {
                firstTime = false;
                return;
            }
            let refineContainer = firstRefine.firstElementChild;
            scrollThreshold = getScrollThreshold(header, refineContainer);
            const translateAmount = scrollThreshold;
            if (document.querySelector('.hero-banner-slim')) {
                scrollThreshold += document.querySelector('.hero-banner-slim').offsetHeight;
            }
            let st = window.pageYOffset || document.documentElement.scrollTop;
            let isBeforeThreshold = st < scrollThreshold;
            let isAfterThreshold = !isBeforeThreshold;
            let isScrollingDown = st > lastScrollTop;
            let scrollDelta = Math.abs(st - cachedScrollTop);
            let scrollingForceIsEnough = scrollDelta >= offsetScroll;
            lastScrollTop = Math.max(0, st);
            if (isBeforeThreshold) {
                refineContainer.classList.remove('sticky');
            }
            if (!scrollingForceIsEnough) {
                return;
            }
            if (!document.body.classList.contains('overlay-open') && isScrollingDown && isAfterThreshold && scrollingForceIsEnough) {
                // downscroll code
                if (header)
                    header.style.transform = `translateY(-${translateAmount}px)`;
                firstRefine.style.transform = `translateY(-${(header === null || header === void 0 ? void 0 : header.offsetHeight) || 0}px)`;
                refineContainer.classList.add('sticky');
            }
            else if (scrollingForceIsEnough) {
                // upscroll code
                header === null || header === void 0 ? void 0 : header.style.removeProperty('transform');
                firstRefine.style.removeProperty('transform');
            }
            cachedScrollTop = lastScrollTop;
        };
        let interval = setInterval(() => {
            // console.info('interval ripetuto ', loop, ' volte');
            firstRefine = document.querySelector('.listing-container .refine');
            if (firstRefine) {
                clearInterval(interval);
                // console.info('init onscroll x gestione sticky');
                window.addEventListener('scroll', onScroll);
            }
            // loop++;
        }, 500);
        return () => {
            header === null || header === void 0 ? void 0 : header.style.removeProperty('transform');
            firstRefine === null || firstRefine === void 0 ? void 0 : firstRefine.style.removeProperty('transform');
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    // start animations effect
    useEffect(() => {
        if (category && firstLoad) {
            // console.info('ho caricato il listing!');
            dispatch({ type: ListingActionTypes.TOGGLE_LANDING_ANIMATION, payload: true });
        }
    }, [category]);
    // const previusH = useRef(1);
    if (!category) {
        return React.createElement("div", { className: "tmploader", dangerouslySetInnerHTML: { __html: props.placeholder } });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Metatags, { pageMetaTags: pageMetaTags, meta: category.meta }),
        React.createElement("noscript", { id: "no-script-pagination" }),
        React.createElement("div", { ref: listingContainer, className: classNames('listing-container', landingAnimation && 'loading') },
            heroBannerSlim && React.createElement(HeroBannerSlim, { heroBannerSlim: heroBannerSlim }),
            React.createElement(ProductFilters, { plpintro: plpintro, willStick: true }),
            featuredProductsCarousel && React.createElement(FeaturedProducts, { featuredProductsCarousel: featuredProductsCarousel }),
            React.createElement(ListingResults, { cgid: props.cgid }),
            React.createElement(ListingPagination, Object.assign({}, props)))));
};
export default PlpPage;
